import React from 'react';
import './Profile.css';

function Profile() {
  return (
    <div className="profile-page">
      <div className="profile-card">
        {/* Profile Header */}
        <div className="profile-header">
          <div className="profile-avatar">
            <span>AR</span>
          </div>
          <div className="profile-info">
            <h1>Ana Reyes</h1>
            <p className="profile-email">ana.reyes@example.com</p>
            <div className="profile-plan">
              <i className="fas fa-crown"></i>
              <span>Pro Plan</span>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="profile-stats">
          <div className="stat-card">
            <span className="stat-number">12</span>
            <span className="stat-label">Characters</span>
          </div>
          <div className="stat-card">
            <span className="stat-number">8</span>
            <span className="stat-label">Environments</span>
          </div>
          <div className="stat-card">
            <span className="stat-number">24</span>
            <span className="stat-label">Videos</span>
          </div>
        </div>

        {/* Menu Items */}
        <div className="profile-menu">
          <button className="profile-menu-item">
            <i className="fas fa-cog"></i>
            <span>Account Settings</span>
          </button>
          <button className="profile-menu-item">
            <i className="fas fa-credit-card"></i>
            <span>Billing & Subscription</span>
          </button>
          <button className="profile-menu-item danger">
            <i className="fas fa-sign-out-alt"></i>
            <span>Sign Out</span>
          </button>
        </div>

        {/* Upgrade CTA */}
        <div className="upgrade-card">
          <h3>Upgrade to Enterprise</h3>
          <p>Get unlimited generations, priority support, and advanced features.</p>
          <button className="xbtn xbtn-md xbtn-primary upgrade-btn">Upgrade Now</button>
        </div>
      </div>
    </div>
  );
}

export default Profile;
